module.exports = function(app) {

    app.filter('employmentStatus', function() {
        return function(code) {
            switch (code) {
                case 'A': return 'Active';
                case 'R': return 'Retired';
                case 'C': return 'Cobra';
            }
        };
    });

};

